import { configureAppInsights } from "appInsightsWeb";
import { initI18n } from "i18n.config";
import { useEffect } from "react";

export function useInitializeGlobals({
  centrixApiUrl,
  appInsightsConnectionString,
}: {
  centrixApiUrl: string;
  appInsightsConnectionString: string;
}) {
  useEffect(() => {
    initI18n(centrixApiUrl);
  }, [centrixApiUrl]);
  useEffect(() => {
    configureAppInsights(appInsightsConnectionString);
  }, [appInsightsConnectionString]);
}
